import {getSelectedTimelineItem} from '@Components/poster-editor/poster-editor-reducer';
import {TimelineItemType} from '@Components/poster-editor/components/timeline/timeline.types';
import {GA4_ITEM_TYPE_MIXED_SELECTION} from '@Libraries/poster-editor-tracking.library';
import {assertNever} from '@Utils/assert-never.util';

/**
 * GA4 ItemType param for a timeline bar: canvas items report their gitype so reports can
 * distinguish trimming a video from moving a text item; the other tracks report their track name.
 */
/** GA4 ItemType param for the current timeline selection; a multi-bar (or no-bar) selection reports as mixed. */
export const getGa4ItemTypeForTimelineSelection = (): string => {
  const selectedTimelineItem = getSelectedTimelineItem(window.PMW.redux.store.getState());
  if (!selectedTimelineItem) {
    return GA4_ITEM_TYPE_MIXED_SELECTION;
  }
  return getTimelineItemGa4Type(selectedTimelineItem.type, selectedTimelineItem.id);
};

export const getTimelineItemGa4Type = (type: TimelineItemType, itemId: string): string => {
  switch (type) {
    case TimelineItemType.ITEM:
      return window.posterEditor?.whiteboard?.getCurrentPage()?.items.itemsHashMap[itemId]?.gitype ?? TimelineItemType.ITEM;
    case TimelineItemType.AUDIO:
    case TimelineItemType.BACKGROUND:
    case TimelineItemType.SUBTITLE:
    case TimelineItemType.TRANSITION:
      return type;
    default:
      return assertNever(type);
  }
};
